<template>
  <div class="agreement">
    <div class="T_content">
      Effective Date: May 28, 2025
      <br /><br />
    </div>
    <div class="T_title" style="text-align: center">
      {{ appName }} Service Agreement
    </div>
    <div class="T_content">
      Please read these Terms of Use carefully, including the terms set forth in
      the Privacy Policy ("Terms", "Terms of Use"), before using this
      application (the "Application") provided by {{ appName }} ("we", "us",
      "our").
    </div>
    <div class="T_content">
      Your access to and use of the Application is conditioned upon your
      acceptance of and compliance with these Terms. These Terms apply to all
      visitors, users and others who wish to access or use the Application.
    </div>
    <div class="T_content">
      The Application is not directed to, nor designed to attract, children
      under the age of 13. By accessing or using the Application, you agree to
      be bound by these Terms. If you disagree with any part of these Terms, you
      are not authorized to access the Application.
    </div>
    <div class="T_content">
      You cannot accept these Terms if: (i) you are not legally entitled to use
      the Application under any applicable laws of the country in which you are
      located or reside; or (ii) if you are not of legal age to enter into a
      binding agreement with Administration. By accepting these Terms, you
      acknowledge and agree that you are of age to enter into such a binding
      agreement in the country in which you are located or reside, or that you
      have obtained the permission of your parent or legal guardian, if required
      by applicable law. It is your responsibility to ensure that you are
      legally permitted to enter into this Agreement and that you are not in
      violation of any applicable laws.
    </div>
    <div class="T_content">
      {{ appName }} and third-party providers may make improvements and/or
      changes to the functionality, features, pricing and availability of the
      App at any time without prior notice. You agree that {{ appName }} shall
      not be liable to you or any third party for any modification, suspension
      or termination of the App or any part thereof.
    </div>
    <br /><br />
    <div class="T_title">Content</div>

    <div class="T_content">
      In addition, the Content found on or through the App is the property of
      {{ appName }} or used with permission. You may not distribute, modify,
      transmit, reuse, download, repost, copy or use the foregoing Content, in
      whole or in part, for commercial purposes or personal gain without our
      prior express written permission. You expressly agree not to access (or
      attempt to access) the App or Content through any automated means
      (including use of any script, crawler, robot, spider or scraper), and you
      will not forge or manipulate identifiers in order to disguise the origin
      of any access (or attempted access) to Content found on or through the
      App.
    </div>
    <br /><br />
    <div class="T_title">Intellectual Property</div>

    <div class="T_content">
      The App and its original content (excluding content provided by users,
      third-party websites or services), features and functionality are and will
      remain the exclusive property of {{ appName }} and its licensors. The App
      is protected by copyright, trademark and other laws of the United States
      and other countries. Our trademarks and trade dress may not be used in
      connection with any product or service without {{ appName }}'s prior
      written consent. <br /><br />
    </div>
    <div class="T_title">Links to Other Websites</div>

    <div class="T_content">
      Our App may contain links to third-party websites or services that are not
      owned or controlled by {{ appName }}. {{ appName }} has no control over
      and assumes no responsibility for the content, privacy policies or
      practices of any third-party websites or services. We do not endorse the
      offerings of any of these entities/individuals or their websites. You
      acknowledge and agree that {{ appName }} shall not be responsible or
      liable, directly or indirectly, for any damage or loss caused or alleged
      to be caused by or in connection with use of or reliance on any such
      content, goods or services available on or through any such third-party
      websites or services. We strongly advise you to read the terms of use and
      privacy policies of any third-party websites or services that you visit.
    </div>
    <br /><br />
    <div class="T_title">Termination</div>

    <div class="T_content">
      We may terminate or bar access to the App immediately, without prior
      notice or liability, in our sole discretion, for any reason, including but
      not limited to breach of the Terms. If you wish to terminate your account,
      you may simply discontinue using the App. All provisions of the Terms that
      by their nature should survive termination shall survive termination,
      including, without limitation, ownership provisions, warranty disclaimers,
      indemnity and limitations of liability. <br /><br />
    </div>
    <div class="T_title">Indemnification</div>

    <div class="T_content">
      You agree to defend, indemnify and hold harmless {{ appName }} and its
      licensees and licensors, and their employees, contractors, agents,
      officers and directors, from and against any and all claims, damages,
      obligations, losses, liabilities, costs or debt, and expenses (including
      but not limited to attorney's fees), arising out of or resulting from a)
      your use and access of the App, by you or anyone using your account and
      password; b) a breach of these Terms, or c) content posted on the App.
    </div>
    <br /><br />
    <div class="T_title">Liability</div>

    <div class="T_content">
      Limitation In no event shall {{ appName }}, its directors, employees,
      partners, agents, suppliers or affiliates be liable for any indirect,
      incidental, special, consequential or punitive damages, including, without
      limitation, damages that may result to your health, loss of profits, loss
      of data or other intangible losses, resulting from: (i) your access to or
      use of or inability to access or use the App; (ii) any conduct or content
      of any third party on the App; (iii) any content obtained from the App;
      and (iv) unauthorized access, use or alteration of your transmissions or
      content, whether based on warranty, contract, tort (including negligence)
      or any other legal theory, whether or not we have been informed of the
      possibility of such damage, and even if a remedy set forth herein is found
      to have failed of its essential purpose.

      <br /><br />
    </div>
    <div class="T_title">Disclaimer</div>

    <div class="T_content">
      Your use of the App is at your own risk. The App is provided on an "as is"
      and "as available" basis. The App is provided without warranties of any
      kind, whether express or implied, including, but not limited to, implied
      warranties of merchantability, fitness for a particular purpose,
      non-infringement or course of performance. {{ appName }}, its
      subsidiaries, affiliates, and its licensors do not warrant that a) the App
      will be uninterrupted, secure or available at any particular time or
      location; b) any errors or defects will be corrected; c) the App is free
      of viruses or other harmful components; or d) the results of the use of
      the App will meet your requirements. <br /><br />
    </div>
    <div class="T_title">Exclusions</div>

    <div class="T_content">
      Some jurisdictions do not allow the exclusion of certain warranties or the
      exclusion or limitation of liability for consequential or incidental
      damages, so the above limitations may not apply to you.
      <br /><br />
    </div>
    <div class="T_title">Governing Law</div>

    <div class="T_content">
      These Terms shall be governed by and construed in accordance with the laws
      of the State of California, U.S.A., without regard to its conflict of law
      provisions. Our failure to enforce any right or provision of these Terms
      shall not be deemed a waiver of those rights. If any provision of these
      Terms is held by a court to be invalid or unenforceable, the remaining
      provisions of these Terms will remain in effect. These Terms constitute
      the entire agreement between us regarding our App, and supersede and
      replace any prior agreements we might have between us regarding the App.
      <br /><br />
    </div>
    <div class="T_title">Changes</div>

    <div class="T_content">
      We reserve the right, at our sole discretion, to modify or replace these
      Terms at any time. By continuing to access or use our App after any
      revisions become effective, you agree to be bound by the revised Terms. If
      you do not agree to the new terms, you are no longer authorized to use the
      App. <br /><br />
    </div>
    <div class="T_title">Contact Us</div>

    <div class="T_content">
      If you have any questions about these terms, please contact us at
      {{ appEmail }} <br /><br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.agreement {
  padding: 0px 25px;
}
.T_title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0.5333rem 0px;
  color: #000;
}
.T_content {
  font-size: 1rem;
  margin-bottom: 0.4667rem;
  color: #666;
}
.title_content {
  font-size: 1rem;
  margin-bottom: 0.4667rem;
  color: #666;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
</style>
